import _SegmentationUtil from './../_SegmentationUtil';

export default [() => {
    return {
        restrict: 'EA',
        controller: ['$element', '$q', 'brandingData', function ($element, $q, brandingData) {
            return _SegmentationUtil($element, $q.resolve(brandingData));
        }]
    };
}];